import { render, staticRenderFns } from "./view.vue?vue&type=template&id=3a23a768&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a23a768",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a23a768')) {
      api.createRecord('3a23a768', component.options)
    } else {
      api.reload('3a23a768', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=3a23a768&scoped=true&", function () {
      api.rerender('3a23a768', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/deviceMgr/view.vue"
export default component.exports